/** Form field name for browser `posthog.get_distinct_id()` (see PosthogDistinctIdField). */
export const POSTHOG_DISTINCT_ID_FORM_FIELD = "posthogDistinctId";

/** Sanitized browser session, page and first-touch context for cart server actions. */
export const POSTHOG_EVENT_CONTEXT_FORM_FIELD = "posthogEventContext";
